import React from 'react';
import { Field } from 'redux-form';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import { PublicCheckbox, UploadImage } from '../../../../common/components';
import { FormGroupInput } from '../../../../common/form/components/components';
import { connect } from 'react-redux';
import {
  WhiteLabelContentContainer
} from '../WLContentContainer/WhiteLabelContentContainer';

const VoteBanner = ({ enabled, handleOpenUpload }) => {
  const handleUpload = () => {
    handleOpenUpload('banner');
  };
  return (
    <WhiteLabelContentContainer title={'Email Banner'}>
      <>
        <FormGroup>
          <Col sm={12}>
            <Field
              name={'meta.whitelabel.vote_banner.enabled'}
              component={PublicCheckbox}
              label={'Enabled'}
            />
          </Col>
        </FormGroup>
        {enabled && (
          <>
            <Field
              name="meta.whitelabel.vote_banner.url"
              component={FormGroupInput}
              label={'Url'}
              labelSize={1}
              colSize={11}
            />
            <FormGroup>
              <Col sm={12}>
                <ControlLabel>Banner Image</ControlLabel>
              </Col>
              <Col sm={12} onClick={handleUpload}>
                <Field
                  name="meta.whitelabel.vote_banner.banner"
                  component={UploadImage}
                />
              </Col>
            </FormGroup>
          </>
        )}
      </>
    </WhiteLabelContentContainer>
  );
};

export default connect()(VoteBanner);
